import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditMyCompanyMemberFinancialRateGroupWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import EditDataIcon from '../assets/images/edit-specification-code-64x64.svg';
import {
  readCompanyMember,
  updateCompanyMemberFinancialRateData,
} from '../redux/actions/table/my_company_members';
import EditMyCompanyMemberFinancialRateFutureGroupForm from '../forms/edit_my_company_member_financial_rate_group_wizard/EditMyCompanyMemberFinancialRateFutureGroupForm';
import EditMyCompanyMemberFinancialRateGroupForm from '../forms/edit_my_company_member_financial_rate_group_wizard/EditMyCompanyMemberFinancialRateGroupForm';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberFinancialRateGroupWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      steps: [
        {
          id: '01',
          title: __('wizard.my-company-members.title.rate-current-group'),
        },
        {
          id: '02',
          title: __('wizard.my-company-members.title.rate-future-group'),
        },
      ],
    };
  }
  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }
  @autobind
  _handleSubmitCurrent(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
    };

    return validateForm(
      updateCompanyMemberFinancialRateData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __('my-company-members.financial.current-rate-group.updated')
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  @autobind
  _handleSubmitFuture(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      is_new: true,
    };

    return validateForm(
      updateCompanyMemberFinancialRateData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __('my-company-members.financial.future-rate-group.updated')
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  render() {
    const { financialRateData } = this.props.store;
    const { steps, active } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.title}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.my-company-members.title.edit-my-company-member-financial-rate-group'
                )}
              </span>
              <span>
                {__(
                  'wizard.my-company-members.subtitle.edit-my-company-member-financial-rate-group'
                )}
              </span>
            </div>
            <div className={styles.right}>
              <EditDataIcon />
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => this._setActiveStep(step.id)}
                className={`
                ${styles.step} 
                ${active === step.id ? styles.active : ''}
              `}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>{' '}
        </div>

        {/* TAB CONTENT */}
        <div className={styles.body}>
          {active === '01' && (
            <EditMyCompanyMemberFinancialRateGroupForm
              onSubmit={this._handleSubmitCurrent}
              initialValues={{
                rate_currency_id:
                  financialRateData?.current?.rate_currency_id || null,
                hourly_rate: financialRateData?.current?.hourly_rate || null,
                chargeout_rate:
                  financialRateData?.current?.chargeout_rate || null,
                rate_start_date:
                  financialRateData?.current?.rate_start_date || null,
                rate_end_date:
                  financialRateData?.current?.rate_end_date || null,
              }}
            />
          )}

          {active === '02' && (
            <EditMyCompanyMemberFinancialRateFutureGroupForm
              onSubmit={this._handleSubmitFuture}
              initialValues={{
                // rate_currency_id:
                //   financialRateData?.future?.rate_currency_id || null,
                rate_currency_id: financialRateData?.future?.rate_currency_id
                  ? financialRateData?.future?.rate_currency_id
                  : financialRateData?.current?.rate_currency_id || null,
                hourly_rate: financialRateData?.current?.hourly_rate || null,
                chargeout_rate:
                  financialRateData?.current?.chargeout_rate || null,
                rate_start_date:
                  financialRateData?.future?.rate_start_date || null,
                rate_end_date: financialRateData?.future?.rate_end_date || null,
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberFinancialRateGroupWizard;
